import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Container, Wrapper } from "./Landing";
import styled from "styled-components";
import { IoIosCheckbox } from "react-icons/io";
import { BiCheckbox } from "react-icons/bi";
import { FaTwitterSquare, FaEthereum, FaDiscord } from "react-icons/fa";
// import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import ReCAPTCHA from "react-google-recaptcha";
const Verification = (props) => {
  const { connectWallet, mintingStatus, saleEnded, isVerified, setIsVerified } =
    props.myFunctions;
  const blockchain = useSelector((state) => state.blockchain);
  const [verifyInfo, setVerifyInfo] = useState({
    isWalletConnect: false,
    isTwitterConnect: false,
    isDiscordConnect: false,
  });
  return (
    <Container>
      <Wrapper>
        <div className="form-row ">
          <h3 className="title fw-bolder">Register</h3>
          <p className="fw-bolder">Follow the steps to whitelist yourself</p>
        </div>
        <div className="form-row fw-bolder">
          <div className=" row border border-2 rounded-3 d-flex justify-content-between  align-items-center ">
            <div className="col-4">
              <img
                src="./config/images/bg.gif"
                className="img-fluid rounded "
              />
            </div>
            <div className="col ">
              <div className=" h-100 text-right d-flex flex-column justify-content-evenly align-items-end">
                <p style={{ fontSize: "smaller" }} className="py-1">
                  Have at least 0.1ETH
                </p>
                <p className="py-1">Follow @oniboy on Twitter</p>
                <p style={{ fontSize: "smaller" }} className="text-right py-1">
                  {" "}
                  Join oniboy Discord server
                </p>
              </div>
            </div>
          </div>
        </div>
        <ConnectWallet>
          <div className="bg-transparent">
            <p>
              {verifyInfo.isWalletConnect ? (
                <IoIosCheckbox className="me-2 bg-success border-success rounded-2 success " />
              ) : (
                <BiCheckbox className="me-2 bg-success border-success rounded-2 success " />
              )}
              Connect Wallet
            </p>

            <button
              disabled={mintingStatus === "MINTING" || saleEnded}
              onClick={(e) => {
                // blockchain.account === "" || blockchain.smartContract === null
                //   ?
                connectWallet(e);
                //   :
                // mintNFT(e);
              }}
              className="btn btn-block"
            >
              {blockchain.account === "" || blockchain.smartContract === null
                ? ` Connect Wallet`
                : mintingStatus}
            </button>
          </div>
          <div className="bg-transparent">
            <p className="">
              {verifyInfo.isTwitterConnect ? (
                <IoIosCheckbox className="me-2 bg-success border-success rounded-2 success " />
              ) : (
                <BiCheckbox className="me-2 bg-success border-success rounded-2 success " />
              )}
              Connect Twitter
            </p>
            <button className="btn btn-block">
              {" "}
              <FaTwitterSquare className="success" /> Join Twitter
            </button>
          </div>
          <div className="bg-transparent">
            <p>
              {verifyInfo.isDiscordConnect ? (
                <IoIosCheckbox className="me-2 bg-success border-success rounded-2 success " />
              ) : (
                <BiCheckbox className="me-2 bg-success border-success rounded-2 success " />
              )}
              Connect Discord
            </p>
            <button className="btn btn-block">
              {" "}
              <FaDiscord /> Join Discord
            </button>
          </div>
        </ConnectWallet>

        <ReCAPTCHA
          className="captcha"
          sitekey="6LdQvYEfAAAAAC4bClvPLpvSoewC0xP4Oz9iFXx0"
          //   onChange={onChange}
        />

        <button
          disabled={mintingStatus === "MINTING" || saleEnded}
          onClick={(e) => {
            // blockchain.account === "" || blockchain.smartContract === null
            //   ?
            connectWallet(e);
            //   :
            // mintNFT(e);
          }}
          className="btn w-100"
        >
          {blockchain.account === "" || blockchain.smartContract === null
            ? "CONNECT WALLET"
            : mintingStatus}
        </button>
      </Wrapper>
    </Container>
    // <div>Verification</div>
  );
};

export default Verification;
const ConnectWallet = styled.div`
  background-color: var(--primary-300);
  padding: 0.3rem 0.7rem;
  border-radius: var(--borderRadius);
  div {
    /* display: flex; */
    /* justify-content: space-between; */
    /* align-items: center; */
    display: grid;
    grid-template-columns: 3fr 2fr;
    margin: 1rem;
    p {
      flex: 3;
    }
  }
`;
